import { render } from "./ItemPanel.vue?vue&type=template&id=244db704&scoped=true&ts=true"
import script from "./ItemPanel.vue?vue&type=script&lang=ts"
export * from "./ItemPanel.vue?vue&type=script&lang=ts"

import "./ItemPanel.vue?vue&type=style&index=0&id=244db704&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244db704"]])

export default __exports__